import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkLayoutSpaces, UitkLayoutSizes, UitkLayout } from 'uitk-react-layout';
import styles from './uitk-layout-columns.css';

var UitkLayoutColumnCountMap = [
    [1, '1'],
    [2, '2'],
    [3, '3'],
    [4, '4'],
    [5, '5'],
    [6, '6'],
    [8, '8'],
    [12, '12']
];
var UitkLayoutColumnCounts = new Map(UitkLayoutColumnCountMap);
var UitkLayoutColumnItemSpanMap = [['all', 'column-span-all']];
var UitkLayoutColumnItemSpans = new Map(UitkLayoutColumnItemSpanMap);
var UitkLayoutColumnItemBreakInsideMap = [['avoid', 'break-inside-avoid']];
var UitkLayoutColumnItemBreakInsides = new Map(UitkLayoutColumnItemBreakInsideMap);
var UitkLayoutColumnItemBreakBeforeMap = [['avoid', 'break-before-avoid']];
var UitkLayoutColumnItemBreakBefores = new Map(UitkLayoutColumnItemBreakBeforeMap);
var UitkLayoutColumnItemBreakAfterMap = [['avoid', 'break-after-avoid']];
var UitkLayoutColumnItemBreakAfters = new Map(UitkLayoutColumnItemBreakAfterMap);

var getClassNameList = classNames.bind(styles);
var UitkLayoutColumns = function (props) {
    var children = props.children, className = props.className, space = props.space, tag = props.tag, columns = props.columns, minWidth = props.minWidth, attributes = __rest(props, ["children", "className", "space", "tag", "columns", "minWidth"]);
    var baseClass = 'uitk-layout-columns';
    var wrapperClassNames = getClassNameList(baseClass, columns && baseClass + "-" + UitkLayoutColumnCounts.get(columns), space && baseClass + "-" + UitkLayoutSpaces.get(space), minWidth && baseClass + "-minwidth-" + UitkLayoutSizes.get(minWidth), className);
    return (React.createElement(UitkLayout, __assign({ className: wrapperClassNames, tag: tag }, attributes), children || null));
};

var UitkLayoutColumnsItem = function (props) {
    var breakAfter = props.breakAfter, breakBefore = props.breakBefore, breakInside = props.breakInside, className = props.className, columnSpan = props.columnSpan, forceNoBreak = props.forceNoBreak;
    var childrenArray = React.Children.toArray(props.children);
    if (!childrenArray.length) {
        return null;
    }
    var firstChild = childrenArray[0];
    var firstChildClassName = firstChild.props.className;
    var baseClass = 'uitk-layout-columns-item';
    var classNames = [
        baseClass,
        firstChildClassName,
        breakAfter && baseClass + "-" + UitkLayoutColumnItemBreakAfters.get(breakAfter),
        breakBefore && baseClass + "-" + UitkLayoutColumnItemBreakBefores.get(breakBefore),
        breakInside && baseClass + "-" + UitkLayoutColumnItemBreakInsides.get(breakInside),
        columnSpan && baseClass + "-" + UitkLayoutColumnItemSpans.get(columnSpan),
        forceNoBreak && baseClass + "-force-no-break",
        className
    ].filter(function (style) { return typeof style === 'string'; });
    var decoratedChild = React.cloneElement(firstChild, {
        className: classNames.join(' ')
    });
    return decoratedChild;
};

export { UitkLayoutColumns, UitkLayoutColumnsItem };
